<tr class="col-12">
  <td class="col-10"><a (click)="viewFile(this.fileDetails)"><span>
        <i class="fa fa-2x m-r-md" [ngClass]="documentService.getIconType(this.fileDetails.name)" aria-hidden="true">
        </i> {{this.fileDetails.name}}</span></a>
  </td>
  <td class="action-column-4buttons">
    <div class="btn-group float-right">
      <button *ngIf="this.fileDetails.name.toUpperCase().substring(this.fileDetails.name.lastIndexOf('.')+1) == 'PDF'"
        class="btn  btn-primary btn-sm t-action-button" (click)="viewFile(this.fileDetails)" title="{{ 'General.visualize' |
        translate }}">
        <i class="fa fa-eye" aria-hidden="true"></i>
      </button>
      <button *ngIf="this.edit" class="btn  btn-primary btn-sm t-action-button" (click)="deleteFile(this.fileDetails)"
        title="{{ 'General.delete' |
      translate }}" disabled="{{this.readonly?'disabled':''}}">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
      <button *ngIf="this.edit&& this.editActive" class="btn  btn-primary btn-sm t-action-button"
        (click)="modifyFile(this.fileDetails)" title="{{ 'General.modify' |
      translate
      }}" disabled="{{this.readonly?'disabled':''}}">
        <i class="fas fa-pencil-alt" aria-hidden="true"></i>
      </button>
      <button class="btn  btn-primary btn-sm t-action-button" (click)="downloadEmbedded(this.fileDetails)" title="{{ 'General.download' |
      translate }}">
        <i class="fas fa-download" aria-hidden="true"></i>
      </button>
    </div>
  </td>
</tr>
<ng-container *ngIf="this.fileDetails.signatures">
  <tr class="col-12" *ngFor="let signature of signatures(this.fileDetails); let o = index">
    <td class="col-10">
      <span class="m-l-lg">
        <img alt="image" style="width:3%" class="d-inline" src="assets/img/CERES.gif" />
        {{signature.date|date:'dd-MM-yyyy HH:mm'}}: {{signature.signer}}</span>
    </td>
    <td class="action-column-4buttons">
      <div class="btn-group float-right" [ngSwitch]="isValidSignature(signature)">
        <button *ngSwitchCase="1" class="btn  btn-primary btn-sm t-action-button"
          (click)="validateSignDocument(signature,this.fileDetails)"
          title="{{ 'DocumentFile.validate.signature' | translate }}">
          <i class="fa fa-check" aria-hidden="true"></i>
        </button>
        <button *ngSwitchCase="-1" class="btn  btn-primary btn-sm t-action-button"
        (click)="validateSignDocument(signature,this.fileDetails)"
        title="{{ 'DocumentFile.validate.signature' | translate }}">
        <i class="fa fa-question-circle" aria-hidden="true"></i>
      </button>
        <button *ngSwitchDefault class="btn  btn-primary btn-sm t-action-button"
          (click)="validateSignDocument(signature,this.fileDetails)"
          title="{{ 'DocumentFile.validate.signature' | translate }}">
          <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        </button>
      </div>
    </td>
  </tr>
</ng-container>